import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PerformanceFlagStore = {
  disableWorkflow: boolean;
  disableNewReplyNotifications: boolean;
  disableMyActivitiesSidebar: boolean;
  disableSystemMessageNotification: boolean;
  disableActivityOpenNotification: boolean;
  disableFooterTabs: boolean;
  useNewItineraryVersion: boolean;
  useNewQuoteVersion: boolean;
  enableProjectBids: boolean;
  setDisableWorkflow: (disable: boolean) => void;
  setDisableNewReplyNotifications: (disable: boolean) => void;
  setDisableMyActivitiesSidebar: (disable: boolean) => void;
  setDisableSystemMessageNotification: (disable: boolean) => void;
  setDisableActivityOpenNotification: (disable: boolean) => void;
  setDisableFooterTabs: (disable: boolean) => void;
  setEnableProjectBids: (enable: boolean) => void;
  toggleAll: (disable: boolean) => void;
};

export const usePerformanceFlagStore = create(
  persist<PerformanceFlagStore>(
    (set) => ({
      disableWorkflow: false,
      disableNewReplyNotifications: false,
      disableMyActivitiesSidebar: false,
      disableSystemMessageNotification: false,
      disableActivityOpenNotification: false,
      disableFooterTabs: false,
      useNewItineraryVersion: false,
      useNewQuoteVersion: false,
      enableProjectBids: false,
      setDisableWorkflow: (disable) => set({ disableWorkflow: disable }),
      setDisableNewReplyNotifications: (disable) => set({ disableNewReplyNotifications: disable }),
      setDisableMyActivitiesSidebar: (disable) => set({ disableMyActivitiesSidebar: disable }),
      setDisableSystemMessageNotification: (disable) => set({ disableSystemMessageNotification: disable }),
      setDisableActivityOpenNotification: (disable) => set({ disableActivityOpenNotification: disable }),
      setDisableFooterTabs: (disable) => set({ disableFooterTabs: disable }),
      setEnableProjectBids: (enable) => set({ enableProjectBids: enable }),
      toggleAll: (disable) =>
        set({
          disableWorkflow: disable,
          disableNewReplyNotifications: disable,
          disableMyActivitiesSidebar: disable,
          disableSystemMessageNotification: disable,
          disableActivityOpenNotification: disable,
          disableFooterTabs: disable
        })
    }),
    {
      name: 'performance-flags'
    }
  )
);
